import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { AppService } from 'src/app/services/app.service';

declare var $:any;

@Component({
  selector: 'combo-product-hotels',
  templateUrl: './combo-product-hotels.component.html',
  styleUrls: ['./combo-product-hotels.component.scss']
})
export class ComboProductHotelsComponent implements OnInit {

  @Input("label") label = null;  
  @Input("value") value = null;
  @Input("text") text   = null;
  @ViewChild("select") select:ElementRef; 
  @Output("changeValue") changeValue = new EventEmitter();
  public comboCtrl        = new UntypedFormControl();
  public comboFilter:Observable<any>;
  public loader         = false;
  public response       = {
    data: [],
    status: null,
    message: ""
  };
  public paramsAtributos = {
    text: "hotelPousada",
    value: "idHotelPousada"
  }
  public data = [];
  public isOpenSelect = false;
  
  constructor(
    private api: ApiService,
    private app: AppService
  ){ }
  
  /**
   * 
   * Retorna os dados para o ComboBox
   * 
   * 
   */
  getData(open=true){

    try{

      this.loader = true;

      this.api.products().product().hotels().subscribe(response => {  

        this.loader = false;
        
        if(response.status == 1){

          this.data            = response.data;
          this.response.status = 1;
          
          if(this.isOpenSelect){
            try{
              setTimeout(() => { 
                //this.initSelect(); 
                $(this.select.nativeElement).select2("close"); 
                if(open){
                  $(this.select.nativeElement).select2("open"); 
                } 
              },100);  
            }catch(e){
              alert(e.message); 
            }
          }  
                  
        }else{

          this.response = {
            data: [],
            status: 500,
            message: response.data
          }

        }  

      },(response) => {

        this.loader = false;

        let error     = this.api.formatError(response);
        this.response = {
          data: [],
          status: 500, 
          message: error.message
        };

      });

    }catch(e){

      this.loader = false;

    }

  }
   /**
   * 
   * Get dataItem
   * 
   */
  _getDataItem(){

    let data = null;

    for(let index = 0; index < this.data.length; index++) {

      if(this.value == this.data[index]["idHotelPousada"]){

        data = this.data[index];
        break;

      }
      
    }

    return data;

  }
  /***
   * 
   * Verifica a mudança
   * 
   */
  _change(){

     
    let item = this._getDataItem();
    
    if(item != null){
      this.changeValue.emit(item);
    }

  }
  /**
  * 
  * 
  * 
  */
  _getData(){
    
    if(this.response.status != 1){
      this.isOpenSelect = true;  
      this.getData();
    }

  }
  initSelect(){

    let self = this;
    
    $(this.select.nativeElement).val(this.value).select2({
      allowClear: false,
      placeholder: 'Selecione um Hotel',
      maximumSelectionLength: 200,
      width: "style",
      language: {
        noResults: function (params) {
          return "Nenhum resultado encontrado";
        }
      }
    });
    $(this.select.nativeElement).on("select2:select", function (e) {

      //this returns all the selected item
      let value = $(this).val();        

      self.value = value;
      self._change();  
  
    });

  }
  /**
   * 
   * Inicializando as Funções
   * 
   */
  ngOnInit(){

  }
  ngAfterViewInit(): void {
    this.initSelect();
  }

}
